/* Deskon - puts a space back where the hero's line break used to be.

   THE PROBLEM. The offer sentence is written "until<br>August 31" - no space, because the break
   was doing a space's job. Desktop hides that <br> to get the line onto one row, and the words
   run together: UNTILAUGUST.

   WHY NOT CSS. Generated content only exists through ::before and ::after, and an element set to
   display: none renders neither. There is no property that turns a <br> into a space: the break
   is a behaviour of the element, not of any style it carries.

   WHAT THIS DOES, AND WHY IT IS SAFE AT EVERY WIDTH. It adds one space BEFORE the <br> and leaves
   the <br> alone. On desktop, where the break is hidden, that space is all that remains between
   the two words. On mobile the break still happens, and a space sitting at the end of a line is
   collapsed by the browser - nothing moves, nothing shifts. So there is no breakpoint test here,
   no resize handler, and no DOM to undo: one insertion, correct in both layouts.

   IDEMPOTENT BY CHECKING FOR WHITESPACE rather than by a flag. Run it twice, or let the theme
   editor re-render the section, and the second pass finds a space already there and does nothing.
   A flag on the element would be lost the moment the editor replaced the markup.

   THIS IS A PATCH, NOT THE FIX. The sentence should read "On all lamps, until August 31" with an
   ordinary space and no <br> at all, edited in Hero > the offer text block. Do that and this file
   quietly stops finding anything to do - it can then be deleted along with the display: none rule
   in deskon-hero-type.css. Until then, the copy in the editor and the copy on screen differ by
   one character, which is exactly the kind of drift worth removing when there is a minute. */

function addSpaceBeforeBreaks() {
  const breaks = document.querySelectorAll('.hero-split-wrapper__promo br');

  for (const br of breaks) {
    const previous = br.previousSibling;

    if (previous && previous.nodeType === Node.TEXT_NODE) {
      if (!/\s$/.test(previous.nodeValue)) {
        previous.nodeValue += ' ';
      }
    } else {
      br.parentNode.insertBefore(document.createTextNode(' '), br);
    }
  }
}

addSpaceBeforeBreaks();
document.addEventListener('shopify:section:load', addSpaceBeforeBreaks);
